import { render, staticRenderFns } from "./ClinicianPatientAssignmentsTabs.vue?vue&type=template&id=1b5b665a"
import script from "./ClinicianPatientAssignmentsTabs.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientAssignmentsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports